module.exports = __webpack_public_path__ + "img/bg_blue_full.529af5e7.webp";